module.exports = __webpack_public_path__ + "static/media/generalInfo.c97cc81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/generalInfo.png
// module id = 596
// module chunks = 0